import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { UtentiPage } from '../../pages/utenti/utenti';
import { ResetpasswordPage } from '../../pages/resetpassword/resetpassword';
import { RicercautentiPage } from '../../pages/ricercautenti/ricercautenti';

/**
 * Generated class for the EdituserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-edituser',
  templateUrl: 'edituser.html',
})
export class EdituserPage {
  userAdmin;
  searchTerm;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,

  ) {
    this.userAdmin = navParams.get('userAdmin');
    this.searchTerm = navParams.get('searchTerm');
  }

  resetpassword() {
    if(this.searchTerm!=null)
    this.navCtrl.push(ResetpasswordPage, { userAdmin: this.userAdmin, searchTerm: this.searchTerm });
    else
    this.navCtrl.push(ResetpasswordPage, { userAdmin: this.userAdmin});


  }
  updateUserAdmin() {
    this.rest.aggiornaUser(this.userAdmin);
    if (this.searchTerm != null)
      this.navCtrl.push(RicercautentiPage, { searchTerm: this.searchTerm }).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });
    else
      this.navCtrl.push(UtentiPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EdituserPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/edituser/edituser.ts